<template>
  <div class="content">
    <form>
      <salary-form :datas="dataall"></salary-form>
      <sklad :datas="dataall"></sklad>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.salary.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {Sklad,SalaryForm} from "@/pages";
export default {
  components: {SalaryForm,Sklad},
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Маош хисоблаш" });
      }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved == null) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  data() {
    return {
      dataall: {
        created_at: new Date().valueOf().toString().slice(0, 10),
        updated_at: new Date().valueOf().toString().slice(0, 10),
        sklad_id : parseInt(localStorage.getItem("sklad_id")),
        user_id: parseInt(localStorage.getItem("user_id")),
        summa:0,
        count_all:0,
        comment: "",
        dollar_rate:0,
        table : [
        ]
      }
    };
  }
};
</script>
